
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brokenbulls",
      function () {
        return require("private-next-pages/brokenbulls/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brokenbulls"])
      });
    }
  